import type { PropsWithChildren } from 'react'
import type { StatusTone } from '@/types/status'

interface StatusBadgeProps extends PropsWithChildren {
  className?: string
  tone: StatusTone
}

export function StatusBadge({ className, tone, children }: StatusBadgeProps) {
  const classes = `status-badge status-badge--${tone}${className ? ` ${className}` : ''}`

  return <span className={classes}>{children}</span>
}
